// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '13.2.0-beta.20260324';
